/**
 * WordPress Vuex Module
 */
import account from './wordpress/account/index'
import media from './wordpress/media/index'
import posts from './wordpress/posts/index'
import pages from './wordpress/pages/index'
import themes from './wordpress/themes/index'
import settings from './wordpress/settings/index'
import status from './wordpress/status'

/**
 * Store state for WordPress module
 */
const state = {
}

/**
 * Action for WordPress module
 */
const actions = {
}

/**
 * Mutations for WordPress module
 */
const mutations = {
}

/**
 * Getters for WordPress module
 */
const getters = {
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
  modules: {
    account,
    posts,
    pages,
    media,
    themes,
    settings,
    status
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/wordpress.js